var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test_menu clearfix"},[_c('a',{staticClass:"item",attrs:{"href":"javascript:;"}},[_c('em',{staticClass:"num"},[_vm._v("01")]),_c('h6',{staticClass:"tit"},[_vm._v("学习态度问卷")]),_c('p',{staticClass:"font"},[_vm._v("learning attitude")])])])
}]

export { render, staticRenderFns }